export const DR_TRADEIN_STATUSBAR_CLICKED = 'DR_TRADEIN_STATUSBAR_CLICKED';
